import classnames from 'classnames'
import classNames from 'classnames'
import { navigate } from 'gatsby'
import { debounce } from 'lodash'
import React, { useState } from 'react'
import {
  MaterialIcon,
  MaterialIconRef,
} from 'src/components/framework/icons/material-icon'
import { useApiClient } from 'src/integrations/stock-reports-client/context'
import { Colors } from 'src/shared/colors'

import { Result } from './result'
import { SearchItem } from './search-item.dto'
import * as styles from './search.module.scss'

const DEBOUNCE_TIME = 100
const MAX_RESULTS = 7

interface Props {
  className?: string
}

export const Search: React.FC<Props> = ({ className = '' }) => {
  const client = useApiClient()

  const [results, setResults] = useState<SearchItem[] | null>(null)
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null)
  const [hidden, setHidden] = useState<boolean>(false)

  const handleSearch = debounce(async (term: string) => {
    if (term.trim() === '' || !term.length) {
      setResults(null)
    } else {
      const { data: res } = await client.searchSecurities(term)
      setResults(res)
    }
  }, DEBOUNCE_TIME)

  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    setSelectedIndex(null)
    handleSearch(e.currentTarget.value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      if (selectedIndex !== null) {
        if (selectedIndex < MAX_RESULTS - 1) {
          setSelectedIndex(selectedIndex + 1)
        }
      } else {
        setSelectedIndex(0)
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      if (selectedIndex !== null && selectedIndex > 0) {
        setSelectedIndex(selectedIndex - 1)
      }
    } else if (e.key === 'Enter' && selectedIndex !== null && !!results) {
      navigate('/' + results[selectedIndex].permalink)
    }
  }

  const handleFocus = () => setHidden(false)
  const handleBlur = () => setHidden(true)

  return (
    <div className={classNames(styles.search, className)}>
      <span className={styles.search__barIcon}>
        <MaterialIcon
          icon={MaterialIconRef.Search}
          size={18}
          color={Colors.Text3}
        />
      </span>
      <input
        className={styles.search__bar}
        type="text"
        name="search"
        placeholder="Search our database of over 63,000 stocks"
        onInput={handleInput}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoComplete={'off'}
      />

      {!!results?.length && (
        <div
          role="searchbox"
          className={classnames(styles.results, {
            [styles.resultsHidden]: hidden,
          })}
        >
          {results.map((response, index) => (
            <Result
              key={response.id}
              result={response}
              selected={index === selectedIndex}
            />
          ))}
        </div>
      )}
    </div>
  )
}
